module.exports = __webpack_public_path__ + "static/media/steve-windmill.bb1d56c9.jpg";